import React, { useEffect, useRef, useState } from "react";
import SmallHeading from "../../common/AmpSmallHeading/AppSmallHeading";
import AmpInput from "../../common/AmpInput/AmpInput";
import { useTranslation } from "react-i18next";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import { extractFormDataFromElm } from "../../../utils/extractFormData";
import RfrInputPhone from "../../rfr/Steps/RfrInputPhone";

export interface EnoticiationFormProps {
    disabled: boolean
    backButtonEnabled: boolean;
    attestValid: boolean;
    email?: string;

    formCallback: (formdata: EnotifFormData) => void;
    backButtonCallBack?: () => void;
    setAttestValid: (flag: boolean) => void;
    resetCallback?: () => void;

    updateKey: number

}

export interface EnotifFormData {
    email: string;
    firstname: string;
    lastname: string;
    phone: string
}

export interface AcceptFormError {
    checkboxError: boolean;
    nameError: boolean;
    phoneError: boolean;
    firstNameError: boolean,
    lastNameError: boolean,
}

export const defaultErrors = {
    checkboxError: false,
    firstNameError: false,
    lastNameError: false,
    nameError: false,
    phoneError: false
}

export default function EnoticiationForm(props: EnoticiationFormProps) {

    const { t } = useTranslation(["login", "propertySelectionList", "property"]);
    const nameRegex = /^[a-zA-Z\-.' ]+$/
    const [phoneNum, setPhoneData] = useState<Record<string, unknown>>({
        "phone": "",
        "phoneExt": ""
    })
    const [errors, setErrors] = useState<AcceptFormError>({
        ...defaultErrors
    })

    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        if(formRef.current){
            checkAttest(formRef.current)
        }
    // eslint-disable-next-line
    }, [props.updateKey, formRef])

    const setPhone = (e) => {
        const { name, value } = e.target;
        const updatePhone = { ...phoneNum };
        updatePhone[name] = value;
        setErrors({
            ...errors,
            phoneError: updatePhone["phone"] === "",
        })
        setPhoneData(updatePhone);
    }

    const checkAttest = (e: HTMLFormElement) => {
        const data = extractFormDataFromElm(e);
        const firstname = String(data["firstname"]);
        const lastname = String(data["lastname"]);
        const phone = `${data["phone"]}${data["phoneExt"]}`.replace(/[- ]/g, "");

        const newErrors = { ...defaultErrors };
        newErrors.phoneError = phone === "" || isNaN(Number(phone));
        newErrors.firstNameError = firstname === "" || !(nameRegex.test(firstname)) || firstname.length < 2;
        newErrors.lastNameError = lastname === "" || !(nameRegex.test(lastname)) || lastname.length < 2;
        newErrors.nameError =  newErrors.firstNameError || newErrors.lastNameError;
        // Early Return
        if (newErrors.nameError || newErrors.phoneError) {
            props.setAttestValid(false);
            setErrors(newErrors);
            return;
        } else {
            props.formCallback({
                email: props.email as string,
                firstname: firstname,
                lastname: lastname,
                phone: phone
            })
        }
        setErrors(newErrors);
    }

    const nameInput = (e: React.ChangeEvent<HTMLInputElement>, type: "fn" | "ln") => {
        const newErrors = {...errors};
        const text = e.target.value;
        switch (type) {
            case "fn":
                newErrors.firstNameError = text === "" || !(nameRegex.test(text)) || text.length < 2;
                break;
            case "ln":
                newErrors.lastNameError = text === "" || !(nameRegex.test(text)) || text.length < 2;
                break;
            default:
                break;
        }

        newErrors.nameError = newErrors.firstNameError || newErrors.lastNameError;
        setErrors(newErrors);
    }

    const fnAria = "reg-fn";
    const lnAria = "reg-ln";
    const phoneAria = "reg-phone";

    return <form ref={formRef}>
        {props.email && <>
            <SmallHeading for={fnAria}>
                {t("mailing.heading-6", { ns: "property" }) as string}
            </SmallHeading>
            <AmpInput name="email" noTimer={true} type="text" id={fnAria} autoComplete="on" errorMessage={""} disabled={props.attestValid} readOnly={true} value={props.email as string} />
        </>}

        <SmallHeading for={fnAria}>
            {t('6-fn') as string}
        </SmallHeading>
        <AmpInput isError={errors.firstNameError} name="firstname" noTimer={true} type="text" id={fnAria} autoComplete="on" errorMessage={""} isValid={!errors.firstNameError} disabled={props.attestValid} onChange={(e) => {nameInput(e, "fn")}}/>

        <SmallHeading for={lnAria}>
            {t('6-ln') as string}
        </SmallHeading>
        <AmpInput isError={errors.lastNameError} name="lastname" noTimer={true} type="text" id={lnAria} autoComplete="on" errorMessage={""} isValid={!errors.lastNameError} disabled={props.attestValid}  onChange={(e) => {nameInput(e, "ln")}}/>
        <AmpFormError errorMessage={t("6-n-error")} error={errors.nameError} />                        <br />

        <SmallHeading for={phoneAria}>
            {t('6-phone') as string}
        </SmallHeading>
        <RfrInputPhone isError={errors.phoneError} disabled={props.attestValid} backSpaceEnabled={true} noPadding={true} label={""} name={"phone"} required={true} data={phoneNum} onInput={(e) => { setPhone(e) }} />
        <AmpFormError errorMessage={t("6-phone-error")} error={errors.phoneError} />                        <br />

        {/* {(props.backButtonEnabled) && <AmpButton atlStyle={true} type="cancel" onClick={() => { props.backButtonCallBack && props.backButtonCallBack() }} text={t("back")} />}
        <AmpButton atlStyle={true} type="submit" onClick={() => { resetAttest(); }} text={t("6-reset")} disabled={!props.attestValid} />
        <AmpButton atlStyle={true} type="submit" onClick={() => { return; }} text={t("agree")} disabled={props.attestValid} /> */}
    </form>
}